import "./style.scss"
import { useEffect } from "react";
import HeaderCom from "../../components/HeaderCom"
import { Outlet } from "react-router-dom";
import FooterCom from "../../components/FooterCom";
// import { systemConfigList } from "../../api/index.js";
import { useDispatch } from "react-redux"
// import { fetchHomePageData } from "../../store/SetWeb";
const Home = () => {
    const dispatch = useDispatch();
    useEffect(() => {

    }, [])
    return (
        <>
            <div className="headerCom">
                <HeaderCom />
            </div>
            <div className="contentBox"> <Outlet />
                <FooterCom />
            </div>

        </>
    )
}
export default Home;